<ri-resolution-ui-sidebar-group-tasks [groups]="taskGroups()">
</ri-resolution-ui-sidebar-group-tasks>
